import React from "react";
import MarketingLayout from "../components/MarketingLayout";
import { BRAND } from "../data/brand";

const EFFECTIVE = "1 January 2025";

function H2({ children }) { return <h2 style={{ fontSize: 18, fontWeight: 700, color: "#dde6f0", margin: "36px 0 10px" }}>{children}</h2>; }
function P({ children })  { return <p style={{ fontSize: 14, color: "#6b7e94", lineHeight: 1.85, margin: "0 0 14px" }}>{children}</p>; }
function Li({ children }) { return <li style={{ fontSize: 14, color: "#6b7e94", lineHeight: 1.85, marginBottom: 6 }}>{children}</li>; }

export default function TermsOfUse() {
  return (
    <MarketingLayout>
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "64px 24px 80px" }}>
        <div style={{ fontSize: 10, color: "#3b82f6", letterSpacing: 2, fontWeight: 800, marginBottom: 10, fontFamily: "'JetBrains Mono',monospace" }}>LEGAL</div>
        <h1 style={{ fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "#dde6f0", marginBottom: 8 }}>Terms of Use</h1>
        <p style={{ fontSize: 12, color: "#2a3a4a", marginBottom: 40 }}>Effective date: {EFFECTIVE} · {BRAND.company}</p>

        <P>Please read these Terms carefully before using DPL Jade. By accessing or using the service you agree to be bound by these Terms. If you do not agree, do not use DPL Jade.</P>

        <H2>1. The Service</H2>
        <P>DPL Jade is a web-based floor-plan drafting and cost-estimation tool operated by {BRAND.company} at {BRAND.website}. We offer a free tier and paid subscription tiers (Pro, Team) as described on our pricing page.</P>

        <H2>2. Eligibility</H2>
        <P>You must be at least 18 years old and capable of entering a binding contract under Indian law to create an account or purchase a subscription. By using DPL Jade you represent that you meet these requirements.</P>

        <H2>3. Account & Security</H2>
        <P>You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. Notify us immediately at <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a> if you suspect unauthorised access.</P>

        <H2>4. Acceptable Use</H2>
        <P>You agree not to:</P>
        <ul style={{ paddingLeft: 20, margin: "0 0 14px" }}>
          <Li>Use DPL Jade for any unlawful purpose or in violation of applicable Indian law.</Li>
          <Li>Attempt to reverse-engineer, decompile or extract source code from the service.</Li>
          <Li>Upload or transmit malicious code, viruses or any content that infringes third-party rights.</Li>
          <Li>Resell or sublicense access to the service without our prior written consent.</Li>
          <Li>Use automated tools to scrape, crawl or stress-test the service.</Li>
        </ul>

        <H2>5. Intellectual Property</H2>
        <P>DPL Jade, its underlying DCEL engine, UI, branding and all related materials are the intellectual property of {BRAND.company} and are protected under Indian copyright law. You are granted a limited, non-exclusive, non-transferable licence to use the service for your personal or business floor-planning needs.</P>
        <P>Your project data (floor plans, BOQs) remains your property. By storing data on our servers you grant us a limited licence to process and display it solely to provide the service.</P>

        <H2>6. Subscriptions & Billing</H2>
        <P>Paid plans are billed in advance on a monthly or annual basis. Subscriptions renew automatically unless cancelled. All prices are in INR and include applicable taxes. We use Razorpay for payment processing; we do not store card details.</P>

        <H2>7. Cancellation & Refunds</H2>
        <P>You may cancel your subscription at any time. Access continues until the end of the paid period. Refunds are available within 7 days of first payment if cloud-sync features have not been used. See our Refund Policy for full details.</P>

        <H2>8. Disclaimer of Warranties</H2>
        <P>DPL Jade is provided "as is" and "as available" without warranties of any kind, express or implied, including fitness for a particular purpose or uninterrupted availability. Cost estimates generated by DPL Jade are indicative only; they are not a substitute for a professional quantity surveyor's assessment.</P>

        <H2>9. Limitation of Liability</H2>
        <P>To the maximum extent permitted by Indian law, {BRAND.company} shall not be liable for any indirect, incidental, special or consequential damages arising from your use of DPL Jade, including loss of data, loss of profits or reliance on cost estimates. Our total liability for any claim shall not exceed the amount you paid to us in the three months preceding the claim.</P>

        <H2>10. Governing Law</H2>
        <P>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of India.</P>

        <H2>11. Changes to Terms</H2>
        <P>We may update these Terms from time to time. We will provide at least 14 days' notice via email before material changes take effect. Continued use constitutes acceptance of revised Terms.</P>

        <H2>12. Contact</H2>
        <P>
          {BRAND.company}<br />
          {BRAND.registeredAddress && <>{BRAND.registeredAddress}<br /></>}
          {BRAND.cin  && <>CIN: {BRAND.cin}<br /></>}
          {BRAND.gstin && <>GSTIN: {BRAND.gstin}<br /></>}
          Email: <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a><br />
          Website: <a href={BRAND.website} style={{ color: "#3b82f6" }}>{BRAND.website}</a>
        </P>
      </div>
    </MarketingLayout>
  );
}
